import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const comparisons = [{
  sin: 'Escribís y rezás',
  con: 'Verificás y presentás'
}, {
  sin: 'La OS rechaza',
  con: 'Vos prevenís el rechazo'
}, {
  sin: 'Ansiedad mensual',
  con: 'Proceso mensual claro'
}, {
  sin: 'Cobrás tarde',
  con: 'Cobrás a término'
}, {
  sin: 'Te sentís inseguro/a',
  con: 'El equipo te respeta'
}, {
  sin: 'Improvisás sesiones',
  con: 'Planificás con criterio'
}, {
  sin: 'Hoja en blanco',
  con: 'Frases listas para usar'
}];
export function ComparisonTable() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-46">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-[#0f1d36] rounded-3xl overflow-hidden border border-[#1a2b4c] shadow-2xl" data-id="element-47">
        <div className="grid grid-cols-2 bg-[#0a1628] border-b border-[#1a2b4c]" data-id="element-48">
          <div className="p-6 text-center border-r border-[#1a2b4c]" data-id="element-49">
            <div className="flex items-center justify-center gap-2 text-red-400 font-bold text-lg md:text-xl" data-id="element-50">
              <X className="w-6 h-6" data-id="element-51" />
              <span data-id="element-52">Sin el Sistema</span>
            </div>
          </div>
          <div className="p-6 text-center bg-[#d4af37]/5" data-id="element-53">
            <div className="flex items-center justify-center gap-2 text-[#d4af37] font-bold text-lg md:text-xl" data-id="element-54">
              <Check className="w-6 h-6" data-id="element-55" />
              <span data-id="element-56">Con el Sistema</span>
            </div>
          </div>
        </div>

        <div className="divide-y divide-[#1a2b4c]" data-id="element-57">
          {comparisons.map((row, index) => <div key={index} className="grid grid-cols-2" data-id="element-58">
              <div className="p-4 md:p-6 text-center border-r border-[#1a2b4c] flex items-center justify-center" data-id="element-59">
                <span className="text-[#a0aec0] text-sm md:text-base" data-id="element-60">
                  {row.sin}
                </span>
              </div>
              <div className="p-4 md:p-6 text-center bg-[#d4af37]/5 flex items-center justify-center" data-id="element-61">
                <span className="text-white font-medium text-sm md:text-base" data-id="element-62">
                  {row.con}
                </span>
              </div>
            </div>)}
        </div>
      </motion.div>
    </section>;
}